export default "__VITE_ASSET__CSkh5KcN__"